import { useEffect, useState } from 'preact/hooks';

interface DomainConfig {
  domain: string;
  allowedDomains: string[];
}

export function useDomainConfig(): DomainConfig | null {
  const [config, setConfig] = useState<DomainConfig | null>(null);

  useEffect(() => {
    fetch('/api/config')
      .then((r) => r.json())
      .then((data) => setConfig(data))
      .catch(() => {
        const host = window.location.hostname;
        setConfig({ domain: host, allowedDomains: [host] });
      });
  }, []);

  return config;
}
